import { forwardRef, createElement } from 'react';

function IconLedgerCardStockAdjustment(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.25 20.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-3.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-3.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm0-3.5a.75.75 0 110 1.5H4.75a.75.75 0 110-1.5h14.5zm-2.5-8a.75.75 0 01.743.648l.007.102v3.439l1.22-1.22a.75.75 0 011.133.977l-.073.084-2.5 2.5a.754.754 0 01-.078.069l.078-.069-.042.04-.052.04-.114.068-.098.038-.084.02-.088.012-.052.002-.052-.002-.119-.018-.098-.03-.1-.047-.082-.054-.08-.069-2.5-2.5a.75.75 0 01.977-1.133l.084.073L16 6.189V2.75a.75.75 0 01.75-.75zm-9.576.004l.128-.002.119.018.098.03.1.047.051.032.038.027.072.064 2.5 2.5a.75.75 0 01-.976 1.133L9.22 5.78 7.999 4.56 8 8a.75.75 0 01-1.493.102L6.5 8l-.001-3.438L5.28 5.78a.75.75 0 01-1.133-.976l.073-.084 2.5-2.5.042-.04.052-.04.114-.068.098-.038.084-.02a.75.75 0 01.064-.01z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var LedgerCardStockAdjustment = /*#__PURE__*/forwardRef(IconLedgerCardStockAdjustment);

export default LedgerCardStockAdjustment;
//# sourceMappingURL=LedgerCardStockAdjustment.js.map
